import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { CgDanger } from "react-icons/cg";

function ErrorTooltip({msg}) {
  return (
  
       <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={
            <Tooltip id={`tooltip-bottom`}>
              <span className='text-danger bolder'>{msg}</span>
            </Tooltip>
          }
        >
          <span><CgDanger className="text-danger fs-4" /></span>
        </OverlayTrigger>
    
  
  );
}

export default ErrorTooltip;